// extracted by css-extract-rspack-plugin
export default {"quiz":"Quiz-module__quiz--LR8JK"};